import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Instagram, Facebook } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { SOCIAL } from "../data/site";

export default function Navbar() {
  const { lang, setLang, t } = useLang();
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => { setOpen(false); }, [loc.pathname]);

  // Original navigation: 6 Tibeter · Lomi Lomi Nui · Über mich · Kontakt
  const items = [
    { to: "/6-tibeter", label: t.nav.tibeter },
    { to: "/lomi-lomi-nui", label: t.nav.lomi },
    { to: "/ueber-mich", label: t.nav.about },
    { to: "/kontakt", label: t.nav.contact },
  ];

  const linkCls = ({ isActive }) =>
    `text-[15px] transition-colors whitespace-nowrap ${
      isActive
        ? "text-white underline underline-offset-4 decoration-white/80"
        : "text-white/90 hover:text-white hover:underline underline-offset-4"
    }`;

  return (
    <header
      data-testid="main-navbar"
      className="fixed top-0 left-0 right-0 z-40 bg-[var(--gold)] border-b border-[var(--gold-dark)]/30 shadow-[0_2px_10px_rgba(0,0,0,0.08)]"
    >
      <div className="container-x flex items-center justify-between h-16 md:h-20">
        <Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="font-serif italic text-[22px] md:text-[30px] tracking-tight text-white drop-shadow-sm" data-testid="logo-link">
          Lotus Sutra
        </Link>

        <nav className="hidden lg:flex items-center gap-7 xl:gap-9">
          {items.map((it) => (
            <NavLink key={it.to} to={it.to} className={linkCls} data-testid={`nav-${it.to.replace('/','')}`}>
              {it.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2 md:gap-3">
          <a href={SOCIAL.instagram} target="_blank" rel="noopener noreferrer"
             className="w-8 h-8 rounded-full border border-white/60 hidden sm:flex items-center justify-center text-white hover:bg-white hover:text-[var(--gold-dark)] transition-all"
             data-testid="nav-instagram" aria-label="Instagram"><Instagram size={14} /></a>
          <a href={SOCIAL.facebook} target="_blank" rel="noopener noreferrer"
             className="w-8 h-8 rounded-full border border-white/60 hidden sm:flex items-center justify-center text-white hover:bg-white hover:text-[var(--gold-dark)] transition-all"
             data-testid="nav-facebook" aria-label="Facebook"><Facebook size={14} /></a>

          <div className="flex items-center gap-1 ml-1 md:ml-2" data-testid="lang-switcher">
            <button onClick={() => setLang("de")} className={`lang-btn ${lang === "de" ? "lang-btn-active" : "text-white"}`} data-testid="lang-de">DE</button>
            <span className="opacity-60 text-xs text-white">/</span>
            <button onClick={() => setLang("en")} className={`lang-btn ${lang === "en" ? "lang-btn-active" : "text-white"}`} data-testid="lang-en">EN</button>
          </div>

          <button className="lg:hidden p-2 text-white" onClick={() => setOpen(!open)} aria-label="menu" data-testid="mobile-menu-toggle">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[var(--gold)] border-t border-white/20" data-testid="mobile-menu">
          <div className="container-x py-5 flex flex-col gap-3">
            {items.map((it) => (
              <NavLink key={it.to} to={it.to} className="text-left text-base text-white py-1.5 border-b border-white/15 last:border-0">
                {it.label}
              </NavLink>
            ))}
            <div className="flex items-center gap-3 pt-2 sm:hidden">
              <a href={SOCIAL.instagram} target="_blank" rel="noopener noreferrer"
                 className="w-9 h-9 rounded-full border border-white/60 flex items-center justify-center text-white"><Instagram size={14} /></a>
              <a href={SOCIAL.facebook} target="_blank" rel="noopener noreferrer"
                 className="w-9 h-9 rounded-full border border-white/60 flex items-center justify-center text-white"><Facebook size={14} /></a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
